import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=33f295a7&scoped=true&"
import script from "./CategorySlider.vue?vue&type=script&lang=js&"
export * from "./CategorySlider.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&id=33f295a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f295a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f295a7')) {
      api.createRecord('33f295a7', component.options)
    } else {
      api.reload('33f295a7', component.options)
    }
    module.hot.accept("./CategorySlider.vue?vue&type=template&id=33f295a7&scoped=true&", function () {
      api.rerender('33f295a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/CategorySlider.vue"
export default component.exports